export default __webpack_public_path__ + "static/media/community.473fd3f7.svg";